module.exports = __webpack_public_path__ + "img/trias.72cc297f.svg";